const p0 = {
  title: "",
  list: [
    "中金支付银行卡快捷支付签约服务协议（以下简称“本协议”）是由合法成立的第三方支付服务提供商，中金支付有限公司（以下简称“中金支付”），与中金支付用户（以下简称“您”）就银行卡快捷支付签约服务的相关事项订立的有效协议。请您在接受服务之前认真阅读以下条款，特别是其中所涉及的对用户行为限制条款、免除或限制中金支付责任的条款等，如果您不同意本协议的任意内容，或者无法准确理解中金支付对条款的解释，请不要进行后续操作。",
    "除非您已阅读并接受本协议所有条款，否则您无权使用中金支付银行卡快捷支付签约服务（以下简称“本服务”）。您对本服务的任何登录、查看或者使用本服务等行为即视为您已阅读并同意本协议的约束。中金支付保留修改本协议之权利，并随时通过本网站公布最新变更事项，而无需另作个别通知。如果您于本协议条款变更后继续使用中金支付服务，即视为您已阅读、了解并同意接受修改或变更。",
    "您在使用本服务时须符合中华人民共和国法律规定、具有完全民事行为能力、能够独立承担民事责任，否则由此引起的损失和纠纷，中金支付不予承担。",
    "您应确保您是使用本服务的银行卡持有人，可合法、有效使用该银行卡且未侵犯任何其他方合法权益，否则因此造成中金支付、持卡人损失的，您应负责赔偿并承担全部法律责任，包括但不限于冻结您全部或部分中金支付账户及资金、从您的前述中金支付账户中扣除相应的款项等。"
  ]
};
const p1 = {
  title: "一、服务内容",
  list: [
    "本协议项下的银行卡快捷支付签约服务是中金支付向用户提供的便捷支付服务，用户在进行支付操作时，需要先在此页面正确、完整的填写银行卡四要素信息：持卡人姓名、身份证号、卡号及银行预留手机号，签约成功后，可进行后续支付。",
    "（本协议中的“第三方”若无特别说明，均指向通过本服务登录、使用具体网站、应用或服务等的用户，提供相应具体网站、应用或其他服务的法人或其他组织。）"
  ]
};
const p2 = {
  title: "二、银行卡快捷支付服务",
  list: [
    "（一）银行卡快捷支付服务。您在使用本服务时，您须通过中金支付提供或中金支付授权提供的登录页面及其他合法通道等进行相关等操作。否则，可能会导致您密码泄漏或其他损失，前述损失您应自行承担。",
    "（二）您使用本服务的同时也应遵循您与第三方之间的协议、约定或第三方相关的规则等。",
    "（三）第三方提供的具体网站、应用或其他服务的合法性、安全性以及真实性应由第三方保证。若因第三方原因，造成您损失的，您不会要求中金支付承担责任。",
    "（四）本服务根据您的指令从您选择的绑定银行卡账户中划转相应款项。",
    "（五）您理解并同意：中金支付在本服务中仅提供了相关的技术服务，通过您或第三方的指令进行资金划转业务。中金支付无法保证第三方网站、应用或服务等的合法性、安全性以及真实性，第三方网站、应用或服务等的质量和安全等由第三方独立负责、承担，您会自行进行判断、甄别、选择，并自行承担相关损失、责任。若您因使用第三方网站、应用或服务等产生的任何纠纷，您应自行与第三方协商或通过其他合法途径解决，中金支付无需对此向您承担任何责任。"
  ]
};
const p3 = {
  title: "三、用户行为限制",
  list: [
    "（一）您理解并同意，您在使用本服务时，应当认真确认交易信息，包括且不限于收款方名称、标的名称、数量、金额等，并按中金支付业务流程发出符合要求的指令。您认可并同意：您发出的指令不可撤回或撤销，中金支付有权根据您的指令委托银行或第三方从您选择的绑定银行卡账户中划转资金给收款方。中金支付对于系统按照收到的符合约定的指令完成支付的行为不承担任何责任。",
    "（二）您理解并同意，您对使用本服务过程中发出指令的真实性及有效性承担全部责任；您承诺，中金支付依照您的指令进行操作的一切风险由您承担。您认可中金支付账户的使用记录数据、交易金额数据等均以中金支付系统平台记录的数据为准。",
    "（三）当您使用本服务时，严禁从事以下行为，否则您的账户将会被注销，且您必须承担一切损害赔偿责任及接受一切法律责任：",
    "1.反对宪法所确定的基本信息服务；",
    "2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
    "3.损坏国家荣誉和利益的；",
    "4.煽动民族仇恨、民族岐视、破坏民族团结的；",
    "5.破坏国家民族宗教政策，宣扬邪教和封建迷信的；",
    "6.散布谣言，扰乱社会秩序，破坏社会稳定的。",
    "7.散布谣言、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的",
    "8.侮辱或者诽谤他人，侵害他人合法权益的；",
    "9.含有法律、行政法规禁止的其他内容的；",
    "10.从事伪造或是偷窃物品之交易；",
    "11.从事任何与赌博性商品或行为有关之交易；",
    "12.侵害第三者之著作权、专利权、商标或商业机密之交易；",
    "13.从事任何违法、有关色情之交易；",
    "14.从事任何可能含有电脑病毒或是任何可能侵害本服务系统、资料之行为；",
    "15.任何可能对本服务造成部份或全部妨害之行为；",
    "16.从事任何违反中华人民共和国相关法律，法规和规定的不正当交易；",
    "17.其他中金支付有正当理由认为不适当的行为。",
    "（五）您充分了解并同意您必须为自己绑定银行卡下的一切行为负责。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。中金支付无法且不会对因前述风险而导致的任何损失或损害承担责任。",
    "（六）本网站中描述的包含但不限于中金支付的商标和相关产品及服务未经本公司书面同意和许可，禁止他人复印、仿效、使用或实施任何其他侵权行为。非经中金支付或其他权利人书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表上述内容。"
  ]
};

const p4 = {
  title: "四、违约责任",
  list: [
    "（一）如果中金支付发现或收到他人举报您的行为违反前述约定或本协议其他约定的，中金支付有权进行独立判断并采取相应措施处理。",
    "（二）中金支付保留对可疑交易、非法交易、高风险交易的独立判断和确定，并按照中国人民银行要求采取相应措施处理。",
    "（三）中金支付有权审核用户网上资金划转业务的用途，对不符合人民银行相关规定的业务，中金支付有权拒绝执行操作；给中金支付造成损失的，中金支付有权依法追究您的责任。",
    "（四）中金支付有权视您的行为性质，采取包括但不限于暂停或终止本服务、追究法律责任等措施。",
    "（五）您违反本条约定，导致任何他方损害的，您应当独立承担责任；中金支付因此遭受损失的，您也应当一并赔偿。"
  ]
};
const p5 = {
  title: "五、免责条款",
  list: [
    "（一）您应当经由中金支付用户系统官方网站或经中金支付合法授权的合作单位网站下载或取得任何有关中金支付服务的资料（包括软件、文档等），并合理使用。如您未按照中金支付指示或因您操作不当下载的资料导致您电脑系统瘫痪或发生任何损坏，您应自行承担相关责任。",
    "（二）您理解并认可因下列原因，致使您无法使用服务或造成您损失的，中金支付将不承担任何责任：",
    "1.中金支付预先通知的系统停机维护、网站升级期间；",
    "2.由于银行、电信运营商系统、线路的故障、调整、升级，或电力中断/终断，或黑客攻击、技术调整或故障、服务器硬件故障的问题等原因造成中金支付系统无法正常运作或者不能或部分不能提供服务；",
    "3.因台风、地震、海啸、洪水、停电、战争等不可抗力之因素，造成中金支付系统障碍不能正常执行业务；",
    "4.法律法规变化或颁布新的法律法规，政策调整或颁布新的政策规定；",
    "5.其他不能合理控制、不可预见或即使预见亦无法避免的事件。"
  ]
};
const p6 = {
  title: "六、争议解决",
  list: [
    "若您、中金支付之间发生任何纠纷或争议，双方首先应友好协商解决；协商不成的，双方均同意将纠纷或争议提交本协议约定的人民法院管辖。"
  ]
};

const p7 = {
  title: "七、适用法律与管辖法院",
  list: [
    "本服务条款之解释与适用，以及与本服务条款有关的争议，均应依照中华人民共和国法律予以处理，并由中金支付注册地址的中华人民共和国法院管辖。"
  ]
};

const content = [p0, p1, p2, p3, p4, p5, p6, p7];
export default {
  content
};
